import styled, { css } from 'styled-components';

import media from '../../../utils/styling/media';

const displayVertical = <P extends { vertical: boolean }>(
  verticalCss: ReturnType<typeof css<P>>,
  horizontalCss: ReturnType<typeof css<P>>,
) => ({ vertical }: P) => {
    if (vertical) return verticalCss;

    return css`
      ${media.xs`
        ${verticalCss}
      `}

      ${media.sm`
        ${horizontalCss}
      `}
    `;
  };

interface StyledIconProps {
  iconColor: string;
  vertical: boolean;
}

export const StyledIcon = styled.svg<StyledIconProps>`
  top: ${({ theme }) => theme?.Message?.iconTop};
  left: 16px;
  width: 48px;
  height: 48px;
  color: ${({ iconColor }) => iconColor};

  ${displayVertical<StyledIconProps>(
  css`
      margin-bottom: 8px;
    `,
  css`
      position: absolute;
      margin-right: 16px;
      margin-bottom: 0;
    `,
)}
`;

interface StyledMessageprops {
  withIcon?: boolean;
  iconColor?: string;
  vertical: boolean;
}

export const StyledMessage = styled.aside<StyledMessageprops>`
  position: relative;  
  align-items: ${({ theme }) => theme?.Message?.alignItems};
  padding: ${({ theme }) => theme?.Message?.padding};
  font-size: ${({ theme }) => theme?.Message?.fontSize};
  border: ${({ color, theme }) => color || theme.colors.mediumGray} 1px solid;
  border-radius: ${({ theme }) => theme?.Message?.borderRadius};
  min-height: ${({ theme }) => theme?.Message?.minHeight};
  box-sizing: border-box;

  ${displayVertical<StyledMessageprops>(
  css`
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center;
    `,
  css<StyledMessageprops>`
      display: ${({ theme }) => theme?.Message?.display};
      align-items: ${({ theme }) => theme?.Message?.alignItems};
      flex-direction: row;
      text-align: left;

      ${({ withIcon }) => withIcon && css`
        padding-left: ${44 + 32}px;
      `}
    `,
)}

  ${StyledIcon} {
    color: ${({ iconColor }) => iconColor};
  }
`;

export const StyledMessageText = styled.span<StyledMessageprops>`
  line-height: 1.5;
  flex: 1;

  ${displayVertical<StyledMessageprops>(
  css`
      width: 100%;
    `,
  css`
      width: auto;
    `,
)}
`;

export const StyledTitle = styled.h1`
  font-size: 17px;
  text-transform: uppercase;
  font-weight: bold;
  margin: ${({ theme }) => theme?.Message?.titleMargin};
`;
